import { render, staticRenderFns } from "./selfAssessmentForm.vue?vue&type=template&id=ba17c278&scoped=true"
import script from "./selfAssessmentForm.vue?vue&type=script&lang=js"
export * from "./selfAssessmentForm.vue?vue&type=script&lang=js"
import style0 from "./selfAssessmentForm.vue?vue&type=style&index=0&id=ba17c278&prod&lang=scss&scoped=true"
import style1 from "./selfAssessmentForm.vue?vue&type=style&index=1&id=ba17c278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba17c278",
  null
  
)

export default component.exports